export const PAPER = 'Paper';
export const SCISSORS = 'Scissors';
export const ROCK = 'Rock';
